import { useQuery } from "@tanstack/react-query";
import { getCustomerSupportFaqReadFaqListapi } from "../../../../api/support/faq";

export const useGetCustomerSupportFaqReadFaqList2 = (
  topicTypeName: string
) => {
  return useQuery({
    queryKey: ["getCustomerSupportFaqReadFaqList2", topicTypeName],
    queryFn: () => getCustomerSupportFaqReadFaqListapi(topicTypeName),
    select: (res) => res?.result,
    enabled: !!topicTypeName, // ✅ null일 땐 호출 안 함
  });
};
